<template>
  <panel-section
    class="ai-visibility-questions-panel"
    :title="title"
    :subtitle="subtitle"
    :padded="false"
    card-class="ai-visibility-questions-panel__card"
  >
    <data-table min-width="675px">
      <template #head>
        <data-table-row header>
          <data-table-cell header width="42%">Question</data-table-cell>
          <data-table-cell header width="22%">Status</data-table-cell>
          <data-table-cell header width="14%" align="right">Position</data-table-cell>
          <data-table-cell header width="22%" align="right">This week</data-table-cell>
        </data-table-row>
      </template>
      <template #body>
        <tracked-question-row
          v-for="row in questions.rows"
          :key="row.questionId"
          :row="row"
        />
      </template>
    </data-table>
    <panel-action-link
      class="ai-visibility-questions-panel__action"
      :to="actionTo"
      @click="$emit('view-all')"
    >
      {{ actionLabel }}
    </panel-action-link>
  </panel-section>
</template>

<script>
import PanelActionLink from '../../../ui/cards/PanelActionLink.vue'
import PanelSection from '../../../ui/cards/PanelSection.vue'
import DataTable from '../../../ui/table/DataTable.vue'
import DataTableRow from '../../../ui/table/DataTableRow.vue'
import DataTableCell from '../../../ui/table/DataTableCell.vue'
import TrackedQuestionRow from './TrackedQuestionRow.vue'

export default {
  name: 'TrackedQuestionsPanel',
  components: {
    PanelActionLink,
    PanelSection,
    DataTable,
    DataTableRow,
    DataTableCell,
    TrackedQuestionRow,
  },
  props: {
    title: {
      type: String,
      default: "Questions we're tracking for you",
    },
    subtitle: {
      type: String,
      default: '',
    },
    questions: {
      type: Object,
      required: true,
      default: function () {
        return {
          rows: [],
          total: 0
        }
      }
    },
    actionTo: {
      type: [Object, String],
      default: null,
    }
  },
  computed: {
    actionLabel () {
      return 'View all questions';
    }
  }
}
</script>

<style lang="scss" scoped>

.ai-visibility-questions-panel__card ::v-deep .ai-visibility-data-table {
  border: 0;
  border-radius: 0;
}

.ai-visibility-questions-panel__action {
  margin: 14px 16px;
}
</style>
